module.exports = __webpack_public_path__ + "img/UG.85d960c4.png";